import { useEffect, useState } from "react";

/**
 * A hook that listens to a CSS media query and returns whether it matches.
 * Updates automatically when the media query result changes.
 *
 * @param query - CSS media query string (e.g., '(min-width: 768px)')
 * @returns boolean indicating whether the media query matches
 *
 * @example
 * ```tsx
 * const isMobile = useMediaQuery('(max-width: 768px)');
 * ```
 */
export function useMediaQuery(query: string) {
  const [state, setState] = useState(false);

  useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setState(event.matches);
    }

    const result = matchMedia(query);
    result.addEventListener("change", onChange);
    setState(result.matches);

    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return state;
}
